// Generated from build58 src/features/taste/localization.ts. Run scripts/generate-taste-reference.cjs.
import { useSyncExternalStore } from 'react';
const englishGenreLabels = {
  가스펠: 'Gospel',
  '갱스터 랩': 'Gangsta Rap',
  기악: 'Instrumental',
  뉴에이지: 'New Age',
  댄스: 'Dance',
  라틴: 'Latin',
  랩: 'Rap',
  레게: 'Reggae',
  록: 'Rock',
  메탈: 'Metal',
  만도팝: 'Mandopop',
  뮤지컬: 'Musicals',
  발라드: 'Ballad',
  보컬: 'Vocal',
  블루스: 'Blues',
  사운드트랙: 'Soundtrack',
  소울: 'Soul',
  싱어송라이터: 'Singer/Songwriter',
  '아동 음악': "Children's Music",
  아시아: 'Asia',
  알앤비: 'R&B',
  '알앤비/소울': 'R&B/Soul',
  애니메이션: 'Anime',
  '어린이 음악': "Children's Music",
  '어덜트 컨템포러리': 'Adult Contemporary',
  얼터너티브: 'Alternative',
  '얼터너티브 록': 'Alternative Rock',
  오페라: 'Opera',
  월드: 'World',
  익스페리멘탈: 'Experimental',
  인디: 'Indie',
  '인디 록': 'Indie Rock',
  '인디 팝': 'Indie Pop',
  일렉트로닉: 'Electronic',
  재즈: 'Jazz',
  컨트리: 'Country',
  클래식: 'Classical',
  '클래식 크로스오버': 'Classical Crossover',
  칸토팝: 'Cantopop',
  코미디: 'Comedy',
  '크리스천 및 가스펠': 'Christian & Gospel',
  '트래디셔널 팝': 'Traditional Pop',
  팝: 'Pop',
  '팝/록': 'Pop/Rock',
  펑크: 'Punk',
  포크: 'Folk',
  '피트니스 및 운동': 'Fitness & Workout',
  '하드 록': 'Hard Rock',
  '하드코어 랩': 'Hardcore Rap',
  '헤비 메탈': 'Heavy Metal',
  홀리데이: 'Holiday',
  힙합: 'Hip-Hop',
  '힙합/랩': 'Hip-Hop/Rap',
  'R&B/소울': 'R&B/Soul',
  'IDM/실험적': 'IDM/Experimental',
  가라오케: 'Karaoke',
  가라지: 'Garage',
  '고스 록': 'Goth Rock',
  '고전주의 클래식': 'Classical Era',
  '공연장 록': 'Arena Rock',
  구자라트: 'Gujarati',
  그런지: 'Grunge',
  '글램 록': 'Glam Rock',
  기타: 'Guitar',
  남아메리카: 'South America',
  남아프리카공화국: 'South Africa',
  낭만주의: 'Romantic',
  '낭만주의 시대': 'Romantic Era',
  낭송: 'Spoken Word',
  네오소울: 'Neo-Soul',
  '뉴 웨이브': 'New Wave',
  다운템포: 'Downtempo',
  단두트: 'Dangdut',
  '더티 사우스': 'Dirty South',
  덥: 'Dub',
  덥스텝: 'Dubstep',
  '데스 메탈/블랙 메탈': 'Death Metal/Black Metal',
  '델타 블루스': 'Delta Blues',
  '독일 팝': 'German Pop',
  '독일 포크': 'German Folk',
  독주곡: 'Solo Instrumental',
  두왑: 'Doo Wop',
  디스코: 'Disco',
  디즈니: 'Disney',
  딕시랜드: 'Dixieland',
  라운지: 'Lounge',
  '라틴 랩': 'Latin Rap',
  '라틴 어반': 'Latin Urban',
  '라틴 재즈': 'Latin Jazz',
  래그타임: 'Ragtime',
  '러버스 록': 'Lovers Rock',
  러시아어: 'Russian',
  '러시아어 록': 'Russian Rock',
  '러시아어 샹송': 'Russian Chanson',
  '러시아어 팝': 'Russian Pop',
  로커빌리: 'Rockabilly',
  로큰롤: 'Rock & Roll',
  '로파이 포크': 'Lo-Fi Folk',
  '루트 레게': 'Roots Reggae',
  '루트 록': 'Roots Rock',
  르네상스: 'Renaissance',
  '릴렉스 음악': 'Relaxation',
  '만다린 팝': 'Mandopop',
  말라얄람: 'Malayalam',
  '메인스트림 재즈': 'Mainstream Jazz',
  '멕시코 음악': 'Mexican Music',
  명상: 'Meditation',
  '명상 음악': 'Meditation Music',
  '모던 댄스홀': 'Modern Dancehall',
  '모던 시대': 'Modern Era',
  '모타운 사운드': 'Motown',
  '무대 작품': 'Stage Works',
  '미국 전통 록': 'American Traditional Rock',
  미니멀리즘: 'Minimalism',
  '바로크 시대': 'Baroque Era',
  바이올린: 'Violin',
  '바일레 펑크': 'Baile Funk',
  '발라드 및 볼레로': 'Ballads & Boleros',
  밥: 'Bop',
  베이스: 'Bass',
  벵골: 'Bengali',
  '보사 노바': 'Bossa Nova',
  보즈푸리: 'Bhojpuri',
  '보컬 재즈': 'Vocal Jazz',
  '보컬 팝': 'Vocal Pop',
  볼레로: 'Bolero',
  볼리우드: 'Bollywood',
  '북아프리카 음악': 'North African Music',
  '브라스와 목관악기': 'Brass & Woodwinds',
  '브라질 음악': 'Brazilian Music',
  '브레이크 비트': 'Breakbeat',
  '브리티시 인베이젼': 'British Invasion',
  브릿팝: 'Britpop',
  블루그래스: 'Bluegrass',
  '블루스 록': 'Blues-Rock',
  '비디오 게임': 'Video Game',
  '빅 밴드': 'Big Band',
  사이키델릭: 'Psychedelic',
  '살사 및 트로피컬': 'Salsa & Tropical',
  삼바: 'Samba',
  '서던 록': 'Southern Rock',
  서프: 'Surf',
  성가: 'Sacred',
  성가극: 'Oratorio',
  성악: 'Vocal',
  세르타네주: 'Sertanejo',
  소카: 'Soca',
  '소프트 록': 'Soft Rock',
  '스무드 재즈': 'Smooth Jazz',
  스윙: 'Swing',
  스카: 'Ska',
  스탠다드: 'Standards',
  '스페인어 팝': 'Pop in Spanish',
  실내악: 'Chamber Music',
  싱어롱: 'Sing-Along',
  '아랍 음악': 'Arabic Music',
  '아랍 팝': 'Arabic Pop',
  아마피아노: 'Amapiano',
  아메리카나: 'Americana',
  아방가르드: 'Avant-Garde',
  '아방가르드 재즈': 'Avant-Garde Jazz',
  아삼: 'Assamese',
  '아웃로 컨트리': 'Outlaw Country',
  '아프로 소울': 'Afro-Soul',
  '아프로 팝': 'Afropop',
  '아프로 포크': 'Afro-Folk',
  '아프로 퓨전': 'Afro-Fusion',
  '아프로 하우스': 'Afro House',
  아프로비트: 'Afro-Beat',
  '아프리카 댄스홀': 'African Dancehall',
  '아프리카 레게': 'African Reggae',
  '아프리카 음악': 'African Music',
  '아프리칸스 음악': 'Afrikaans Music',
  악세: 'Axé',
  앰비언트: 'Ambient',
  '앰비언트 아메리카나': 'Ambient Americana',
  '앰비언트 컨트리': 'Ambient Country',
  '앰비언트 포크': 'Ambient Folk',
  '어덜트 얼터너티브': 'Adult Alternative',
  '어번 카우보이': 'Urban Cowboy',
  '언더그라운드 랩': 'Underground Rap',
  '얼터너티브 랩': 'Alternative Rap',
  '얼터너티브 및 라틴 록': 'Alternative & Latin Rock',
  '얼터너티브 컨트리': 'Alternative Country',
  '얼터너티브 포크': 'Alternative Folk',
  연주곡: 'Instrumental',
  '영국 힙합': 'UK Hip-Hop',
  '영혼의 안식과 평화': 'Spiritual',
  '예술 가곡': 'Art Song',
  '오리지널 스코어': 'Original Score',
  오케스트라: 'Orchestral',
  '올드스쿨 랩': 'Old School Rap',
  '월드 뮤직': 'World Music',
  월드비트: 'Worldbeat',
  '웨스트 코스트 랩': 'West Coast Rap',
  유럽: 'Europe',
  음악: 'Music',
  '이스라엘 음악': 'Israeli Music',
  '이스트 코스트 랩': 'East Coast Rap',
  '이슬람 음악': 'Islamic Music',
  '이지 리스닝': 'Easy Listening',
  인더스트리얼: 'Industrial',
  인도: 'India',
  '인도 민속 음악': 'Indian Folk',
  '인도 음악': 'Indian Music',
  '인도 클래식': 'Indian Classical',
  '인도 팝': 'Indian Pop',
  일렉트로니카: 'Electronica',
  '일렉트릭 블루스': 'Electric Blues',
  '일본 만화 영화': 'Anime',
  자장가: 'Lullabies',
  '잼 밴드': 'Jam Bands',
  전체: 'All',
  '정글/드럼 앤 베이스': "Jungle/Drum 'n' Bass",
  '종교 음악': 'Religious Music',
  중국: 'China',
  '중국 얼터너티브': 'Chinese Alternative',
  '중국 힙합': 'Chinese Hip-Hop',
  '중세 시대': 'Medieval Era',
  '찬양과 예배': 'Praise & Worship',
  첼로: 'Cello',
  '추억의 명곡': 'Oldies',
  칸나다: 'Kannada',
  '칼리지 팝': 'College Pop',
  '캐리비안 음악': 'Caribbean',
  컨템포러리: 'Contemporary',
  '컨템포러리 R&B': 'Contemporary R&B',
  '컨템포러리 가수/작곡가': 'Contemporary Singer/Songwriter',
  '컨템포러리 가스펠': 'Contemporary Gospel',
  '컨템포러리 라틴': 'Contemporary Latin',
  '컨템포러리 블루그래스': 'Contemporary Bluegrass',
  '컨템포러리 블루스': 'Contemporary Blues',
  '컨템포러리 재즈': 'Contemporary Jazz',
  '컨템포러리 컨트리': 'Contemporary Country',
  '컨템포러리 켈트': 'Contemporary Celtic',
  '컨템포러리 포크': 'Contemporary Folk',
  '컨트리 블루스': 'Country Blues',
  '컬리지 록': 'College Rock',
  케이준: 'Cajun',
  켈틱: 'Celtic',
  '켈틱 민속 음악': 'Celtic Folk',
  '콰이어트 스톰': 'Quiet Storm',
  '쿠바 음악': 'Cuban Music',
  '크로스오버 재즈': 'Crossover Jazz',
  크리스마스: 'Christmas',
  '크리스마스: 록': 'Christmas: Rock',
  '크리스마스: 어린이': 'Christmas: Children',
  '크리스마스: 클래식': 'Christmas: Classical',
  '크리스마스: 팝': 'Christmas: Pop',
  크리스천: 'Christian',
  '크리스천 랩': 'Christian Rap',
  '크리스천 메탈': 'Christian Metal',
  '크리스천 팝': 'Christian Pop',
  '클래식 블루스': 'Classic Blues',
  '타밀 음악': 'Tamil',
  '태국 팝': 'Thai Pop',
  테크노: 'Techno',
  '튀르키예 팝': 'Turkish Pop',
  '튀르키예 힙합/랩': 'Turkish Hip-Hop/Rap',
  '트래디셔널 재즈': 'Traditional Jazz',
  '트래디셔널 컨트리': 'Traditional Country',
  '트래디셔널 포크': 'Traditional Folk',
  트랜스: 'Trance',
  '티구르 음악': 'Tigrinya Music',
  '틴 팝': 'Teen Pop',
  파고지: 'Pagode',
  '팝 펑크': 'Pop Punk',
  펀자브: 'Punjabi',
  '펀자브 팝': 'Punjabi Pop',
  포로: 'Forró',
  '포크 록': 'Folk-Rock',
  퓨전: 'Fusion',
  프랑스: 'France',
  '프랑스 팝': 'French Pop',
  '프로그레시브 록/아트 록': 'Prog-Rock/Art Rock',
  플라멩코: 'Flamenco',
  피아노: 'Piano',
  '하드 밥': 'Hard Bop',
  하드록: 'Hard Rock',
  하드코어: 'Hardcore',
  하르얀비: 'Haryanvi',
  하우스: 'House',
  '한국 음악': 'Korean Music',
  '한국 전통 음악': 'Korean Traditional Music',
  '한국 포크 팝': 'Korean Folk-Pop',
  합창: 'Choral',
  핼러윈: 'Halloween',
  '헤어 메탈': 'Hair Metal',
  호주: 'Australia',
  '홍콩 팝': 'Cantopop',
  '홍키 통크': 'Honky Tonk',
  힐링: 'Healing',
  '한국 댄스': 'Korean Dance',
  '한국 록': 'Korean Rock',
  '한국 발라드': 'Korean Ballad',
  '한국 알앤비': 'Korean R&B',
  '한국 인디': 'Korean Indie',
  '한국 일렉트로닉': 'Korean Electronic',
  '한국 포크': 'Korean Folk',
  '한국 힙합': 'Korean Hip-Hop',
};
const normalizedGenre = (value) => value.trim().replace(/\s+/g, ' ');
let remoteEnglishGenreLabels = {};
let genreCatalogRevision = 0;
const genreCatalogListeners = new Set();
export function setRemoteMusicGenreCatalog(genres) {
  remoteEnglishGenreLabels = Object.fromEntries(
    genres
      .map((genre) => [normalizedGenre(genre.nameKo), normalizedGenre(genre.nameEn)])
      .filter(([nameKo, nameEn]) => Boolean(nameKo && nameEn)),
  );
  genreCatalogRevision += 1;
  genreCatalogListeners.forEach((listener) => listener());
}
export function useMusicGenreCatalogRevision() {
  return useSyncExternalStore(
    (listener) => {
      genreCatalogListeners.add(listener);
      return () => {
        genreCatalogListeners.delete(listener);
      };
    },
    () => genreCatalogRevision,
    () => genreCatalogRevision,
  );
}
/**
 * Music data contains Apple Music's stored Korean genre labels. Keep the source
 * value intact for search and recommendation logic, and translate only the
 * known taxonomy at presentation. Unknown labels are intentionally preserved
 * because they can be proper genre names supplied by the catalog rather than
 * app-owned copy.
 */
export function getLocalizedMusicGenre(value, locale) {
  const label = normalizedGenre(value);
  if (locale !== 'en' || !label) return label;
  const exact = remoteEnglishGenreLabels[label] ?? englishGenreLabels[label];
  if (exact) return exact;
  if (label.startsWith('한국 ')) {
    const base = remoteEnglishGenreLabels[label.slice(3)] ?? englishGenreLabels[label.slice(3)];
    if (base) return `Korean ${base}`;
  }
  return label;
}
// Backward-compatible name for taste modules that already consume the same
// catalog taxonomy. New album metadata surfaces use the music-wide name.
export const getLocalizedTasteGenre = getLocalizedMusicGenre;
export function getLocalizedTasteDecade(value, locale) {
  const label = value.trim();
  if (locale !== 'en') return label;
  return label.replace(/^(\d{4})년대$/, '$1s');
}
